import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <p
        className="select-none text-8xl font-black leading-none text-foreground-100 md:text-9xl"
        aria-hidden="true"
      >
        404
      </p>
      <h1 className="mt-4 text-2xl font-bold text-foreground-950 md:text-3xl">Page not found</h1>
      <p className="mt-2 text-sm text-foreground-500">{location.pathname}</p>
      <p className="mt-1 text-sm text-foreground-400">Tell me more about this page, so I can generate it</p>
      <Link
        to="/"
        className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
      >
        Back to Home
      </Link>
    </div>
  );
}